module.exports = __webpack_public_path__ + "2c22ebdb4d.png";